// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__2013j","employee-header-item":"Header_employee-header-item__vnPRW"};